<template>
  <div>
    <h4 class="title has-text-centered is-4">{{ title }}</h4>

    <ul>
      <li v-for="user in users" :key="user.id">
        <router-link :to="`/users/${user.id}`">
          - {{ user.name }} ({{ user.email }})
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'quest-users',
  props: {
    users: Array,
    title: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
